import { Routes, Route, NavLink, Link, Outlet } from 'react-router-dom';
import styles from './App.module.css';
import UPDATES_LOG from './updatesData';

import Home from './pages/Home';
import Scanner from './pages/Scanner';
import Updates from './pages/Updates';

import NotFound from './pages/status/NotFound';

function MainLayout() {
  const currentVersion = UPDATES_LOG[0].version;

  return (
    <div className="main-layout">
      <nav className={styles.nav_bar}>
        <div className={styles.logo_container}>
          <Link to="/home" className="nav-logo" style={{ textDecoration: 'none' }}>
            RBX-SCANNER
          </Link>
          <span className={styles.version_tag}>{currentVersion}</span>
        </div>

        <div className={styles.nav_links}>
          <NavLink
            to="/"
            end
            className={({ isActive }) => (isActive ? "active_tab" : "")}
          >
            HOME
          </NavLink>

          <NavLink
            to="/scanner"
            className={({ isActive }) => (isActive ? "active_tab" : "")}
          >
            SCANNER
          </NavLink>

          <NavLink
            to="/updates"
            className={({ isActive }) => (isActive ? "active_tab" : "")}
          >
            UPDATES
          </NavLink>
        </div>
      </nav>

      <Outlet />
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/scanner" element={<Scanner />} />
        <Route path="/updates" element={<Updates />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;